<form (ngSubmit)="onSubmit()" [formGroup]="formGroup">
  <h2 mat-dialog-title i18n="@@action.add-material-dialog.addmaterial">Add material</h2>

  <app-loader *ngIf="isLoading()" containerClass="on-dialog"></app-loader>

  <ng-container *ngIf="!isLoading()">
    <mat-dialog-content>
      @if (allowModeChange) {
        <div class="mode-radio-buttons">
          <app-radio-button-group>
            <app-radio-button
              (changeEvent)="onChangeType(modeEnum.ADD_NEW)"
              [checked]="mode === modeEnum.ADD_NEW"
              [label]="translations.addNewLabel"
              [value]="modeEnum.ADD_NEW"
            ></app-radio-button>
            &nbsp;
            <app-radio-button
              (changeEvent)="onChangeType(modeEnum.ADD_EXISTING)"
              [checked]="mode === modeEnum.ADD_EXISTING"
              [label]="translations.addExistingLabel"
              tpPlacement="right"
              [value]="modeEnum.ADD_EXISTING"
            ></app-radio-button>
          </app-radio-button-group>
        </div>
      }

      @if (mode === modeEnum.ADD_NEW) {
        <app-input
          [autofocus]="!isLoading()"
          formControlName="name"
          [label]="translations.nameLabel"
        ></app-input>

        <app-input-select
          [options]="categoriesOptions"
          [addOnWrite]="true"
          formControlName="category"
          [hint]="translations.categoryHint"
          [label]="translations.categoryLabel"
        ></app-input-select>

        <app-input
          [autofocus]="!isLoading()"
          formControlName="commonName"
          [label]="translations.commonNameLabel"
        ></app-input>

        <app-input
          [autofocus]="!isLoading()"
          formControlName="scientificName"
          [label]="translations.scientificNameLabel"
        ></app-input>

        @if (visibleCustomFields?.length) {
          <app-custom-fields-edit
            [elementCustomFields]="[]"
            [formGroup]="formGroup"
            [enableViewMode]="data?.enableInputViewMode"
            [visibleCustomFields]="visibleCustomFields"
          ></app-custom-fields-edit>
        }
      } @else if (mode === modeEnum.ADD_EXISTING) {
        <app-input-select
          [options]="materialOptions"
          formControlName="existingMaterial"
          [label]="translations.materialLabel"
        ></app-input-select>
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      <app-button-group>
        <app-button (pressed)="onClose()" type="ghost" i18n="@@shared.cancel">Cancel</app-button>
        <app-button [disabled]="isSubmitButtonDisabled" accessibilityRole="submit">
          <mat-icon icon-left>check</mat-icon>
          {{ saveButtonText }}
        </app-button>
      </app-button-group>
    </mat-dialog-actions>
  </ng-container>
</form>
